var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleC = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68091 2.68071C3.05581 2.30581 3.66351 2.30581 4.03841 2.68071L21.3184 19.9607C21.6933 20.3356 21.6933 20.9433 21.3184 21.3182C20.9579 21.6787 20.3822 21.6923 20.0052 21.3595H19.7758C19.3781 21.3595 19.0558 21.0371 19.0558 20.6395C19.0558 20.5706 19.0656 20.504 19.0836 20.4409L3.55771 4.91501C3.49477 4.93308 3.42845 4.94337 3.35966 4.94337C2.96204 4.94337 2.6397 4.62098 2.63966 4.22337V3.99368C2.30686 3.61666 2.32044 3.04122 2.68091 2.68071Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35966 19.0556C3.7573 19.0556 4.07966 19.3779 4.07966 19.7756V19.9195H4.22357C4.62121 19.9195 4.94357 20.2418 4.94357 20.6395C4.94353 21.0371 4.62119 21.3595 4.22357 21.3595H3.35966C2.96204 21.3595 2.6397 21.0371 2.63966 20.6395V19.7756C2.63966 19.3779 2.96201 19.0556 3.35966 19.0556Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54357 19.9195C8.94121 19.9195 9.26357 20.2418 9.26357 20.6395C9.26353 21.0371 8.94119 21.3595 8.54357 21.3595H6.81575C6.41813 21.3595 6.09579 21.0371 6.09575 20.6395C6.09575 20.2418 6.41811 19.9195 6.81575 19.9195H8.54357Z",
    fill: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8636 19.9195C13.2612 19.9195 13.5836 20.2418 13.5836 20.6395C13.5835 21.0371 13.2612 21.3595 12.8636 21.3595H11.1358C10.7381 21.3595 10.4158 21.0371 10.4158 20.6395C10.4158 20.2418 10.7381 19.9195 11.1358 19.9195H12.8636Z",
    fill: "#464646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1836 19.9195C17.5812 19.9195 17.9036 20.2418 17.9036 20.6395C17.9035 21.0371 17.5812 21.3595 17.1836 21.3595H15.4558C15.0581 21.3595 14.7358 21.0371 14.7358 20.6395C14.7358 20.2418 15.0581 19.9195 15.4558 19.9195H17.1836Z",
    fill: "#464646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35966 14.7356C3.7573 14.7356 4.07966 15.0579 4.07966 15.4556V17.1834C4.07962 17.581 3.75728 17.9034 3.35966 17.9034C2.96204 17.9034 2.6397 17.581 2.63966 17.1834V15.4556C2.63966 15.0579 2.96201 14.7356 3.35966 14.7356Z",
    fill: "#464646"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35966 10.4156C3.7573 10.4156 4.07966 10.7379 4.07966 11.1356V12.8634C4.07962 13.261 3.75728 13.5834 3.35966 13.5834C2.96204 13.5834 2.6397 13.261 2.63966 12.8634V11.1356C2.63966 10.7379 2.96201 10.4156 3.35966 10.4156Z",
    fill: "#464646"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35966 6.09556C3.7573 6.09556 4.07966 6.41791 4.07966 6.81556V8.54337C4.07962 8.94098 3.75728 9.26337 3.35966 9.26337C2.96204 9.26337 2.6397 8.94098 2.63966 8.54337V6.81556C2.63966 6.41791 2.96201 6.09556 3.35966 6.09556Z",
    fill: "#464646"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleC);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/triangle_c.bc3337057ae47b2e4b343a03d2c5eb19.svg";